import {
  type FilterOption,
  EABFilterImplementationType,
  type EABFilterImplementation,
  EABFilterType,
} from "@/graphql";
import type { EventFilter, ActionFilter } from "../FilterTypes";
import IDFilterBadge from "../ui/badges/IDFilterBadge.vue";
import IDFilterUI from "../ui/IDFilterUI.vue";
import notEmpty from "@/functions/notEmpty";

export default class IDFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly ids: number[],
    public readonly typeId?: number,
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = IDFilterBadge;

  static readonly UI = IDFilterUI;

  getEventFilter(): FilterOption | undefined {
    const typeFilter: EABFilterImplementation | undefined = this.typeId
      ? {
          type: EABFilterImplementationType.EVENT_TYPE_ID,
          value: {
            value: [this.typeId],
            negated: this.isNegated ?? false,
          },
        }
      : undefined;

    const idFilter: EABFilterImplementation | undefined =
      this.ids.length > 0
        ? {
            type: EABFilterImplementationType.EVENT_ID,
            value: {
              value: this.ids,
              negated: this.isNegated ?? false,
            },
          }
        : undefined;

    const filters = [typeFilter, idFilter].filter(notEmpty).map((filter) => ({ filter }));

    if (filters.length === 0) {
      return undefined;
    }

    return {
      operation: {
        type: EABFilterType.AND,
        filters,
      },
    };
  }
  getActionFilter(): FilterOption | undefined {
    const typeFilter: EABFilterImplementation | undefined = this.typeId
      ? {
          type: EABFilterImplementationType.ACTION_TYPE_ID,
          value: {
            value: [this.typeId],
            negated: this.isNegated ?? false,
          },
        }
      : undefined;

    const idFilter: EABFilterImplementation | undefined =
      this.ids.length > 0
        ? {
            type: EABFilterImplementationType.ACTION_ID,
            value: {
              value: this.ids,
              negated: this.isNegated ?? false,
            },
          }
        : undefined;

    const filters = [typeFilter, idFilter].filter(notEmpty).map((filter) => ({ filter }));

    if (filters.length === 0) {
      return undefined;
    }

    return {
      operation: {
        type: EABFilterType.AND,
        filters,
      },
    };
  }
}
